// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"5b48845b","354":"7485bd8c","463":"a2201f19","464":"eb9c585c","515":"577874de","583":"f7d2c85c","614":"f5d65a78","714":"6c4fd674","751":"fa121493","868":"c43caa56","898":"be890ef6"}[chunkId] + ".chunk.js";
};